import React, { useEffect, useState } from "react";
import "./HeaderPage.css";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import homeLogo from "../../Assets/HeaderImage/homelogoImage.png";

const HeaderPage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  const scrollToSection = (id, highlightCard) => {
    // Scroll to section
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    // If a card highlight is needed, dispatch the event after a short delay
    // (delay allows scroll to settle so the card is visible when highlighted)
    if (highlightCard) {
      setTimeout(() => {
        window.dispatchEvent(
          new CustomEvent("programme-highlight", {
            detail: { card: highlightCard },
          })
        );
      }, 600);
    }

    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!isMenuOpen) return;
    const handleOutside = (e) => {
      if (!e.target.closest(".headerPage-container")) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, [isMenuOpen]);

  const navItems = [
    { label: "Home", id: "home" },
    // highlightCard tells Programme which card to spotlight
    { label: "Learning", id: "programme", highlightCard: "learning" },
    { label: "Service",  id: "programme", highlightCard: "service"  },
    { label: "Why Alphaingen", id: "whychoose" },
    { label: "Enroll", id: "endroll", highlight: true },
  ];

  return (
    <header className={`headerPage ${scrolled ? "scrolled" : ""}`}>
      <div className="headerPage-container">
        <img
          src={homeLogo}
          alt="Home Logo"
          className="logo-image"
          onClick={() => scrollToSection("home")}
        />

        <nav className={`headerPage-nav-links ${isMenuOpen ? "open" : ""}`}>
          {navItems.map(({ label, id, highlight, highlightCard }) => (
            <button
              key={label}
              className={highlight ? "highlight-btn" : ""}
              onClick={() => scrollToSection(id, highlightCard)}
            >
              {label}
            </button>
          ))}
        </nav>

        <div
          className="headerPagemenu-icon"
          onClick={toggleMenu}
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          role="button"
        >
          {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
        </div>
      </div>
    </header>
  );
};

export default HeaderPage;